import { render, staticRenderFns } from "./Coin.vue?vue&type=template&id=6b27aba3&scoped=true&"
import script from "./Coin.vue?vue&type=script&lang=ts&"
export * from "./Coin.vue?vue&type=script&lang=ts&"
import style0 from "./Coin.vue?vue&type=style&index=0&id=6b27aba3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b27aba3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VImg,VListItem,VListItemContent})
